import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

const variants = {
  default: 'xl:container xl:mx-auto',
  thin: 'max-w-(--breakpoint-lg) mx-auto',
  extraThin: 'max-w-(--breakpoint-sm) mx-auto',
} as const;

export type ContainerVariants = keyof typeof variants;

export const Container = ({
  className = '',
  variant = 'default',
  ...rest
}: HTMLAttributes<HTMLDivElement> & { variant?: ContainerVariants }) => (
  <div
    className={twMerge(`${variants[variant]} px-6 sm:px-11 md:px-14 lg:px-16`, className)}
    {...rest}
  />
);
